import { IoIosCamera } from "react-icons/io";
import { useEffect, useState, useRef } from "react";
import { uploadFileToAzure } from "../../services/azure";
import { useStores } from "../../store";
export function ProfilePic() {
  const { UserStore } = useStores();
  const [showCam, setShowCam] = useState(false);
  const fileInputRef = useRef(null);
  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const userGoogleDetails = JSON.parse(localStorage.getItem("user"));
  const [profile, setProfile] = useState(userGoogleDetails?.pic);

  useEffect(() => {
    if (UserStore.userPic) {
      setProfile(UserStore.userPic)
    }
    else {
      setProfile(userGoogleDetails?.pic);
    }
  }, [UserStore.userPic]);

  useEffect(() => {
    setProfile(userGoogleDetails?.pic);
  }, []);

  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";
  return (
    <div className="relative" >
      <input type="file" accept=".png, .jpeg, .jpg" className="hidden" ref={fileInputRef} multiple={false} onChange={async (e) => {

        const timestamp = Date.now().toString();
        const min = 1000;
        const max = 9999;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        const filename = randomNumber + timestamp;
        const fileUploaded = await uploadFileToAzure(filename, e.target.files[0], { action: "profile" });

        // console.log(fileUploaded.url);
        const stringifiedURL = JSON.stringify(fileUploaded.url);
        localStorage.setItem("pic", stringifiedURL);
        setProfile(fileUploaded.url);
        UserStore.setUserPic(fileUploaded.url);
        let body = { pic: fileUploaded.url };
        await UserStore.updateUserDetailsToServer(body).then((res) => {
          console.log(res);
        });

      }} />
      {showCam ? <img
        src={`${profile}`}
        alt=" "
        className="w-[80px]  h-[80px] hover:brightness-50 hover:blur-[3px] cursor-pointer  rounded-full"
        style={{
          backgroundImage: `url(${defaultProfile})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onMouseEnter={() => setShowCam(true)}
        onMouseLeave={() => setShowCam(false)}
        onClick={handleButtonClick}
      /> : <img
        src={`${profile}`}
        alt=" "
        className="w-[80px]  h-[80px]  hover:brightness-50 hover:blur-[3px]  rounded-full"
        style={{
          backgroundImage: `url(${defaultProfile})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onerror="this.parentNode.removeChild(this);"
        onMouseEnter={() => setShowCam(true)}
        onMouseLeave={() => setShowCam(false)}
      />}
      {showCam ? <IoIosCamera onMouseEnter={() => setShowCam(true)} onMouseLeave={() => setShowCam(false)} onClick={handleButtonClick} className="absolute top-7 left-7 text-2xl text-white" /> : null}


    </div>
  );
}